<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Clock',

  computed: {

    ...mapGetters([
      'inGameHours',
      'inGameMinutes'
    ]),

    visibleHours () {
      return '' + (this.inGameHours < 10 ? 0 : '') + this.inGameHours
    },

    visibleMinutes () {
      return '' + (this.inGameMinutes < 10 ? 0 : '') + this.inGameMinutes
    }

  }

}
</script>

<template>
  <div class="c-clock">
    {{ visibleHours }}<span class="c-clock-indicator">:</span>{{ visibleMinutes }}
  </div>
</template>

<style lang="scss">

.c-clock-indicator {
  @include animation(c-clock-indicator, 2s);
}

@keyframes c-clock-indicator {

  0%,
  50% {
    opacity: 0;
  }

  51%,
  100% {
    opacity: 1;
  }

}

</style>
